import { supabase } from '../lib/supabase';

// ============================================================
// GROWTH OPPORTUNITIES SERVICE
// ============================================================
export const growthOpportunitiesService = {
  async getAll(partnerId) {
    let query = supabase?.from('growth_opportunities')?.select('*')?.order('created_at', { ascending: false });
    if (partnerId) query = query?.eq('partner_id', partnerId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async create(oppData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const { data, error } = await supabase
      ?.from('growth_opportunities')
      ?.insert({ ...oppData, created_by: user?.id })
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async update(id, updates) {
    const { data, error } = await supabase
      ?.from('growth_opportunities')
      ?.update({ ...updates, updated_at: new Date()?.toISOString() })
      ?.eq('id', id)
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  }
};

// ============================================================
// REVENUE TARGETS SERVICE
// ============================================================
export const revenueTargetsService = {
  async getAll(partnerId) {
    let query = supabase?.from('revenue_targets')?.select('*')?.order('year', { ascending: false });
    if (partnerId) query = query?.eq('partner_id', partnerId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async create(targetData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const { data, error } = await supabase
      ?.from('revenue_targets')
      ?.insert({ ...targetData, created_by: user?.id })
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async update(id, updates) {
    const { data, error } = await supabase
      ?.from('revenue_targets')
      ?.update({ ...updates, updated_at: new Date()?.toISOString() })
      ?.eq('id', id)
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  }
};

// ============================================================
// TRAINING RECORDS SERVICE
// ============================================================
export const trainingRecordsService = {
  async getAll(partnerId) {
    let query = supabase?.from('partner_trainings')?.select('*, partners(legal_name, brand_name)')?.order('created_at', { ascending: false });
    if (partnerId) query = query?.eq('partner_id', partnerId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async create(trainingData) {
    const { data, error } = await supabase
      ?.from('partner_trainings')
      ?.insert(trainingData)
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  },

  async update(id, updates) {
    const { data, error } = await supabase
      ?.from('partner_trainings')
      ?.update(updates)
      ?.eq('id', id)
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  }
};
